import { render, staticRenderFns } from "./hsnp_wizard_step_02_weekprice_relative.vue?vue&type=template&id=a0458a52&scoped=true"
import script from "./hsnp_wizard_step_02_weekprice_relative.vue?vue&type=script&lang=js"
export * from "./hsnp_wizard_step_02_weekprice_relative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0458a52",
  null
  
)

export default component.exports